import React from "react";
import { PointGiftCardEditor } from "../features/point-gift-cards";
import { withRestaurantId } from "../shared/components/layout";

const PointGiftCardEditorWithId = withRestaurantId(PointGiftCardEditor);

const PointGiftCardPage: React.FC = () => {
  return <PointGiftCardEditorWithId />;
};

export default PointGiftCardPage;
